<template>
  <div class="about">
    <h1>Rooms for {{ $route.params.description }}</h1>
    <Room/>
  </div>
</template>

<script>
import Room from '@/components/Room/Room.vue'
export default {
  name: 'RoomAdmin',
  components: {
    Room
  }
}
</script>
